import { lightTheme } from '@/customTheme'

const SVGComponent = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.14914 20.8788H20.0922C21.9229 20.8788 23 19.8096 23 17.7611V7.88825C23 5.83984 21.9151 5.75 19.8509 5.75H10.9184C10.2328 5.75 9.8167 4.61182 9.29176 4.17656L8.74075 3.73113C8.06915 3.17798 7.57265 3 6.56696 3H3.85C2.06117 3 1 4.04466 1 6.0589V17.7611C1 19.8175 2.0771 20.8788 4.14914 20.8788ZM4.25819 18.998C3.36559 18.998 2.88079 18.5376 2.88079 17.6031V6.22133C2.88079 5.34006 3.36098 4.87292 4.22382 4.87292H6.07488C6.74476 4.87292 7.14776 5.03785 7.68401 5.47484L8.23331 5.92815C8.9005 6.46727 9.41275 7.63252 10.4185 7.63252H19.734C20.6187 7.63252 21.1192 7.12141 21.1192 8.05414V17.611C21.1192 18.5376 20.6187 18.998 19.734 18.998H4.25819Z"
      fill={props.fill ? props.fill : lightTheme.colors.blackGray}
    />
  </svg>
);
export default SVGComponent;
